  import React from "react";
  import Modal from "react-modal";
  import "./UI_modalCss.css";

  Modal.setAppElement("#root");

  export default function UI_Modal({
    isOpen,
    children,
    closeModal,
    title,
    styleTop,
    styleLeft,
    styleUnit,
  }) {
    let styleModel = {
      content: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: '#212226',
        width: '40%',
        maxWidth: "50%",  
        borderRadius: "1rem",
        outline:"none",
        overflow: "auto",
      },
      overlay:{backgroundImage:' linear-gradient(90deg , #3b3d49,#212226)'}
    };
    if (styleTop) {
      styleModel.content.top = styleTop + (styleUnit || "%");
    }
    if (styleLeft) {
      styleModel.content.left = styleLeft + (styleUnit || "%");
    }

    return (
      <Modal
        isOpen={isOpen}
        // onRequestClose={closeModal}
        style={styleModel}
        className="user_input_modal"
      >
        <div className=" rounded p-2 drop-shadow-2xl w-full PayRenderContainer">
          <div
            className="border-b-2 flex justify-between text-white pt-4 pb-2 ml-[50px] mr-[20px]"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <span className="Syne700 text-3xl text-white ">{title}</span>
            <span className="text-[#f1a044]  bg-[#3b3d49] text-center rounded px-[10px] py-[6px] mb-1" onClick={closeModal} style={{ cursor: "pointer" }}>
            &#10005;
            </span>
          </div>
          <div>{children}</div>
        </div>
      </Modal>
    );
  }
